import moment from 'moment';
import {reverseShortDate} from '../../common/constants/datesFormat';

const today = moment().format(reverseShortDate);

export const genericItemComplement = '9999';

export const emptyHeaderValues = {
  'orderNumber': '',
  'origin': '',
  'provider': '',
  'dateOfShipment': today,
  'dateOfArrival': today,
  'year_model': '',
  'nlLines': 0,
  'flLines': 0,
  'dpLines': 0,
  'total': 0,
};

export const emptyTempOrder = {
  'id': 0,
  'orderNumber': '',
  'model': '',
  'sfx': '',
  'sfxAndModel': '',
  'colors': '',
  'internalcolor': '',
  'externalcolor': '',
  'port': '',
  'total': '',
  'fl': '',
  'tde': '',
  'tdedp': '',
  'cl': '',
  'ch': '',
  'cb': '',
  'tcomercial': '',
  'it': '',
  'ty': '',
  'price': 0,
  'internalColorDescription': '',
  'externalColorDescription': '',
  'avaliableColors': [],
};

export const emptyShipment = {
  'orderNumber': '',
  'shipment': '',
  'totalUnits': 0,
  'cif': 0,
  'dateOfShipment': today,
  'dateOfArrival': today,
};
